import request from '@/utils/request';
/* 秒杀活动-秒杀列表 */
export function modelFunList(data) {
  return request({
    url: '/sec/kill/querySecKillPageList',
    method: 'POST',
    data
  });
}
/* 秒杀活动-秒杀列表-增加 */
export function modelFunAdd(data) {
  return request({
    url: '/sec/kill/saveSecKill',
    method: 'POST',
    data
  });
}
/* 秒杀活动-秒杀列表-修改 */
export function modelFunEdit(data) {
  return request({
    url: '/sec/kill/updateSecKill',
    method: 'POST',
    data
  });
}
/* 秒杀活动-秒杀列表-修改中的信息展示 */
export function modelFunInfo(data) {
  return request({
    url: '/sec/kill/fetchSecKillDetailById',
    method: 'POST',
    data
  });
}
/* 秒杀活动-秒杀列表-删除 */
export function modelFunDel(data) {
  return request({
    url: '/sec/kill/removeSecKillById',
    method: 'POST',
    data
  });
}
/* 秒杀活动-秒杀列表-复制 */
export function copySecKill(data) {
  return request({
    url: '/sec/kill/copySecKill',
    method: 'POST',
    data
  });
}
/* 秒杀活动-秒杀列表-上下架操作 */
export function modelFunSwitchList(data) {
  return request({
    url: '/sec/kill/enableSecKillById',
    method: 'POST',
    data
  });
}
/* 秒杀活动-秒杀列表-商品列表 */
export function modelFunGoodsList(data) {
  return request({
    url: '/sec/kill/goods/bind/querySecKillGoodsBindPageList',
    method: 'POST',
    data
  });
}
/* 秒杀活动-秒杀列表-商品列表-添加商品弹窗中的商品列表 */
export function modelFunAddGoodsList(data) {
  return request({
    url: '/sec/kill/goods/querySecKillGoodsList',
    method: 'POST',
    data
  });
}
/* 秒杀活动-秒杀列表-商品列表-添加商品操作 */
export function modelFunAddGoodsSave(data) {
  return request({
    url: '/sec/kill/goods/bind/saveSecKillGoodsBind',
    method: 'POST',
    data
  });
}
/* 秒杀活动-商品列表-删除操作 */
export function modelFunGoodsDel(data) {
  return request({
    url: '/sec/kill/goods/removeSecKillGoodsById',
    method: 'POST',
    data
  });
}
/* 秒杀活动-秒杀列表-商品列表-删除操作 */
export function removeSecKillGoodsByKillIdAndGoodsId(data) {
  return request({
    url: '/sec/kill/goods/bind/removeSecKillGoodsByKillIdAndGoodsId',
    method: 'POST',
    data
  });
}
/* 秒杀活动-商品列表 */
export function querySecKillGoodsPageList(data) {
  return request({
    url: '/sec/kill/goods/querySecKillGoodsPageList',
    method: 'POST',
    data
  });
}
/* 秒杀活动-商品列表-上架或下架操作 */
export function enableSecKillGoodsById(data) {
  return request({
    url: '/sec/kill/goods/enableSecKillGoodsById',
    method: 'POST',
    data
  });
}
/* 秒杀活动-商品列表-添加商品-查询所有上架的商品列表 */
export function queryAllEnableGoodsList(data) {
  return request({
    url: '/sec/kill/goods/queryAllEnableGoodsList',
    method: 'POST',
    data
  });
}
/* 秒杀活动-商品列表-添加商品-新增操作 */
export function saveSecKillGoods(data) {
  return request({
    url: '/sec/kill/goods/saveSecKillGoods',
    method: 'POST',
    data
  });
}
/* 秒杀活动-商品列表-添加商品-编辑操作 */
export function updateSecKillGoods(data) {
  return request({
    url: '/sec/kill/goods/updateSecKillGoods',
    method: 'POST',
    data
  });
}
/* 秒杀活动-商品列表-添加商品-编辑时的商品管理明细 */
export function fetchSecKillGoodsDetailById(data) {
  return request({
    url: '/sec/kill/goods/fetchSecKillGoodsDetailById',
    method: 'POST',
    data
  });
}
/* 秒杀活动-秒杀订单 */
export function querySecKillOrderPageList(data) {
  return request({
    url: '/sec/kill/querySecKillOrderPageList',
    method: 'POST',
    data
  });
}
/* 秒杀活动-秒杀订单-获取秒杀活动列表 */
export function queryAllSecKillList(data) {
  return request({
    url: '/sec/kill/queryAllSecKillList',
    method: 'POST',
    data
  });
}
/* 秒杀活动-秒杀订单-获取秒杀商品列表 */
export function queryAllSecKillGoodsList(data) {
  return request({
    url: '/sec/kill/goods/queryAllSecKillGoodsList',
    method: 'POST',
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/seckill.js